import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const NoData = ({ message, theme }) => {
    return  (
        <Box color={theme && theme.theme? "#fff": ''} display="flex" justifyContent="center" height="100vh" pt={2}>
            <Typography style={{fontSize: 20}}>
                { message } 
            </Typography>
        </Box> 
    );
}

export default NoData;